/** Default page size for holdings list. */
export const HOLDINGS_PAGE_SIZE = 25;
